import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import StatusInfoCard from "./StatusInfoCard";
import { useEffect, useState } from "react";
import { getMeasurementCodesByQuery } from "components/axios/specAxios";

const OpInfoCard = ({ title, opModeName, type = null, message = null }) => {
    const { t } = useTranslation();
    const [displayName, setDisplayName] = useState(opModeName);

    useEffect(() => {
        if (!opModeName) return;

        if (type === "direction") {
            const loadDirection = async () => {
                const codes = opModeName.split(",").map(code => code.trim());
                const names = [];

                for (const code of codes) {
                    try {
                        const result = await getMeasurementCodesByQuery({ code });
                        const name = result?._embedded?.measurementCodes?.[0]?.name || code;
                        names.push(name);
                    } catch (err) {
                        console.error(`Failed to load measurement code: ${code}`, err);
                        // 에러가 나더라도 원래 코드를 밀어넣어 전체 UI가 깨지지 않도록 방어
                        names.push(code);
                    }
                }

                setDisplayName(names.join(", "));
            };

            loadDirection();
        } else {
            setDisplayName(opModeName);
        }
    }, [type, opModeName]);

    if (!opModeName) return null;

    return (
        <StatusInfoCard title={title} cardType="charts_text">
            <Box
                sx={{
                    borderRadius: 2,
                    p: 1.5,
                    boxSizing: "border-box",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    className="no_circle"
                >
                    {displayName}
                </Box>
            </Box>
        </StatusInfoCard>
    );
};

export default OpInfoCard;